import './Dashboard.css';
import { FiHome, FiLayers, FiUsers, FiFileText, FiTrendingUp, FiMail } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import PageLoader from '../../components/common/PageLoader';

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [properties, projects, agents, blogs, inquiries] = await Promise.all([
        httpAction({ url: apis().getListingList, silent: true }),
        httpAction({ url: apis().getProjectListingListAll, silent: true }),
        httpAction({ url: apis().getUserList, silent: true }),
        httpAction({ url: `${apis().blogList}?admin=1`, silent: true }),
        httpAction({ url: apis().contactList, silent: true }),
      ]);
      setStats([
        { label: 'Total Properties', value: properties?.list?.length || 0, icon: <FiHome />, trend: 'Dynamic data' },
        { label: 'Active Projects', value: projects?.list?.length || 0, icon: <FiLayers />, trend: 'Dynamic data' },
        { label: 'Agents', value: agents?.list?.length || 0, icon: <FiUsers />, trend: 'Dynamic data' },
        { label: 'Blog Posts', value: blogs?.list?.length || 0, icon: <FiFileText />, trend: 'Dynamic data' },
        { label: 'Inquiries', value: inquiries?.list?.length || 0, icon: <FiMail />, trend: 'Dynamic data' },
      ]);
      setLoading(false);
    })();
  }, []);

  if (loading) return <PageLoader label="Loading dashboard..." />;

  return (
    <div className="admDash">
      <div className="admDash__head"><div><h2 className="admDash__title">Dashboard</h2><p className="admDash__sub">Overview of listings, projects, content, and contact inquiries</p></div></div>
      <div className="admDash__grid">
        {stats.map((s) => (
          <div className="admDash__card" key={s.label}><div className="admDash__icon">{s.icon}</div><div className="admDash__info"><div className="admDash__value">{s.value}</div><div className="admDash__label">{s.label}</div></div><div className="admDash__trend"><FiTrendingUp /><span>{s.trend}</span></div></div>
        ))}
      </div>
      <div className="admDash__placeholder"><h4>Professional CMS foundation is now in place</h4><p>Blogs, contact page details, footer links, partners, and contact submissions now run through APIs instead of hardcoded content.</p></div>
    </div>
  );
}
